import { env } from "../../internal/env";

/**
 * Access environment configuration
 */
export const useEnv = () => {
	return env;
};
